import './join.scss';
import * as React from 'react';
import { EmployeeBenefits } from '../../components/join/employeeBenefits';
import { SectionTitle } from '../../components/layout/sectionTitle';
import { BackToTop } from '../../components/layout/shell/backToTop';
import Footer from '../../components/layout/shell/footer';
import { SplitPaneCopy } from '../../components/layout/splitPaneCopy';
import { View } from '../../components/layout/view';
import { ImageGallery } from '../../components/media/imageGallery';
import { EmployeeQuotes } from '../../components/quotes/employeeQuotes';
import useJoin from '../../hooks/staticQueries/join/useJoin';
import { useNoHero } from '../../hooks/useHeaderFade';
export const JoinPage = () => {
    useNoHero();
    const { page } = useJoin();
    return (<View title="Join" className="join" noHero>
      <SectionTitle title={page.top_copy.header} description={page.top_copy.description} imageTicket={page.top_copy.icon[0].ticket} button={{ children: 'More Info', to: page.workable_url, variant: 'brand-tertiary-2' }}/>

      <ImageGallery autoplay images={page.top_images.map((image) => ({ ticket: image.image[0].ticket, caption: image.caption }))}/>

      {page.copy &&
        page.copy.map((copySection, i) => (<SplitPaneCopy markdown={copySection.markdown} image={copySection.image[0] && { ...copySection.image[0], alt: 'Join us image' }} key={i}/>))}

      <EmployeeBenefits />

      {page.second_copy &&
        page.second_copy.map((copySection, i) => (<SplitPaneCopy markdown={copySection.markdown} image={copySection.image[0] && { ...copySection.image[0], alt: 'Join us image' }} key={i}/>))}

      <SectionTitle title="Testimonials"/>

      <EmployeeQuotes />

      <SectionTitle button={{ children: 'More Info', to: page.workable_url, variant: 'brand-tertiary-2' }}/>

      <BackToTop />

      <Footer />
    </View>);
};
export default JoinPage;
